import logger from '../common/safe-log';

const GAEventMapping = {
  'Page Start': {
    gaEventName: 'Page Start',
  },
  'Page View': {
    gaEventName: 'Page View',
  },
  'Landing Page': {
    gaEventName: 'Landing Page'
  },
  'Landing Page Start': {
    gaEventName: 'Landing Page Start'
  },
  'Presell Page Start': {
    gaEventName: 'Presell Page Start'
  },
  'Presell Page': {
    gaEventName: 'Presell Page'
  },
  'Splash Page Start': {
    gaEventName: 'Splash Page Start'
  },
  'Splash Page': {
    gaEventName: 'Splash Page'
  },
  'Bundles Loaded': {
    gaEventName: 'view_item_list'
  },
  'Select Bundle': {
    gaEventName: 'add_to_cart'
  },
  'Yes To Inline Upsell': {
    gaEventName: 'add_to_cart'
  },
  'Presell-PopupAccept': {
    gaEventName: 'add_to_cart'
  },
  'Remove Bundle': {
    gaEventName: 'remove_from_cart'
  },
  'Remove Upsell': {
    gaEventName: 'remove_from_cart'
  },
  'View Cart': {
    gaEventName: 'view_cart'
  },
  'Initiate Checkout': {
    gaEventName: 'begin_checkout'
  },
  'Shipping Info': {
    gaEventName: 'add_shipping_info'
  },
  'Billing Info': {
    gaEventName: 'add_payment_info'
  },
  'Order Conversion': {
    gaEventName: 'purchase'
  },
};

const module = 'GA4';
const GA4 = {
  load: (pixelId, async = true) => {
    try {
      if (!window.gtag && pixelId) {
        /* eslint-disable */

        (function (d) {
          var file = 'https://www.googletagmanager.com/gtag/js?id=' + pixelId;
          var ref = d.getElementsByTagName('script')[0];
          var js = d.createElement('script');
          js.src = file;
          js.async = async;
          ref.parentNode.insertBefore(js, ref);
        }(document));
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          window.dataLayer.push(arguments);
        }
        window.gtag('js', new Date());
        window.gtag('config', pixelId, {
          'site_speed_sample_rate': 100,
          'linker': {
            'accept_incoming': true
          }
        });
      } else if (pixelId) {
        window.gtag('config', pixelId, {
          'site_speed_sample_rate': 100,
          'linker': {
            'accept_incoming': true
          }
        });
      }
      /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, {module});
    }
  },
  trackEvent: (eventProperties) => {
    try {
      logger.info('GA4 track event', {eventProperties});
      if (window.gtag && window.gu_ga4_id) {
        const eventName = eventProperties.eventName;
        const eventConfig = GAEventMapping[eventName];

        let gaEventName = eventConfig?.gaEventName ?? eventName;
        let gaProperties = GA4.buildGaEventProperties(eventProperties, eventConfig);
        logger.info('GA4 Event fired', {gaProperties});
        const eventTrack = GA4.track(gaEventName, gaProperties, window.gu_ga4_id);
        return {eventTrack};
      } else {
        logger.warn('GA4 not fired', {eventProperties, gu_ga4_id: window.gu_ga4_id, gtag: !!window.gtag});
      }
    } catch (e) {
      logger.error('trackEvent failed', e, {module});
    }
  },
  buildGaEventProperties: (eventProperties) => {
    try {
      let {
        propertyMeta,
        eventName,
        propertyValue
      } = eventProperties;
      let ga4Event = {
        currency: propertyMeta && propertyMeta.currency ? propertyMeta.currency : 'USD',
        value: propertyValue ?? '',
        shipping: propertyMeta && propertyMeta.shipping_cost ? propertyMeta.shipping_cost : null,
        tax: propertyMeta && propertyMeta.tax_total ? propertyMeta.tax_total : null,
        item_list_id: propertyMeta && propertyMeta.offer_id ? propertyMeta.offer_id : null,
        item_list_name: propertyMeta && propertyMeta.offer_name ? propertyMeta.offer_name : null,
        items: []
      };
      if (propertyMeta && propertyMeta.items) {
        propertyMeta.items.forEach((item, index) => {
          ga4Event.items.push({
            item_id: item.sku,
            item_name: item.name,
            index: index,
            price: item.price,
            quantity: item.qty
          });
        });
      }
      if (eventName === 'Order Conversion' && propertyMeta) {
        ga4Event.transaction_id = propertyMeta.friendly_id || propertyMeta.id;
      }
      return ga4Event;
    } catch (e) {
      logger.error('buildGa4EventProperties failed', e, {module});
      return {};
    }
  },
  track: (gaEvent, gaArgs, send_to = null) => {
    try {
      if (send_to) {
        gaArgs.send_to = send_to;
      }

      window.gtag('event', gaEvent, gaArgs);

      return {gaEvent, gaArgs};
    } catch (e) {
      logger.error('track failed', e, {module});
    }
  },
};
export default GA4;